import io from "socket.io-client";

export const socket = io('https://max3d.xanhchin.io');